"use strict";

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _require = require("ve-range-utils"),
    adjustRangeToInsert = _require.adjustRangeToInsert;

var _require2 = require("lodash"),
    map = _require2.map;

module.exports = function adjustAnnotationsToInsert(annotationsToBeAdjusted, insertStart, insertLength) {
  return map(annotationsToBeAdjusted, function (annotation) {
    return _extends({}, adjustRangeToInsert(annotation, insertStart, insertLength), annotation.locations && {
      locations: annotation.locations.map(function (loc) {
        return adjustRangeToInsert(loc, insertStart, insertLength);
      })
    });
  });
};